import React from "react";
import { Avatar, Button, Dropdown, Menu } from "antd";
import { UserOutlined, DownOutlined } from "@ant-design/icons";
import "./appNewHeader.scss";
import RadiolinqLogo from "../../../assets/images/radiolinq_logo_blue_with_white.png";
import AuthContainer from "../../../store/container/AuthContainer";
import { AuthReducerProps } from "../../../store/reducers/authReducer";
import { useHistory } from "react-router-dom";
import { AppRoutes } from "../../../routes/routeConstants/appRoutes";
interface NewHeaderProps extends AuthReducerProps {
  handleLogout: () => void;
}

const AppNewHeader = ({ user, handleLogout }: NewHeaderProps) => {
  const userName = user?.name || `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
  const history = useHistory();

  const isMobile = window.innerWidth <= 768;

  const handleNavigateReports = () => {
    history.push(AppRoutes.REPORTS_LIST);
  }
  const menu = (
    <Menu>
      {
        isMobile && (
        <Menu.Item key="reports" onClick={handleNavigateReports}>Reports</Menu.Item>
        )
      }
      <Menu.Item key="logout" onClick={handleLogout}>Logout</Menu.Item>
    </Menu>
  );

  return (
    <div className="app-new-header">
      <div className="app-new-header__left">
        <img 
          src={RadiolinqLogo} 
          alt="App Logo" 
          className="app-new-header__img" 
          onClick={() => {
            history.push(AppRoutes.REPORTS_LIST)
          }}/>
          {
            !isMobile && (
            <div className="app-new-header__title">
              <Button onClick={handleNavigateReports}>Your Reports</Button>
            </div>
            )
          }
      </div>
      <div className="app-new-header__right">
        <Dropdown overlay={menu} trigger={["click"]} placement="bottomRight">
          <div className="app-new-header__user">
            <Avatar className="app-new-header__avatar" icon={<UserOutlined />} />
            <span className="app-new-header__username">{userName}</span>
            <DownOutlined className="app-new-header__dropdown-arrow" />
          </div>
        </Dropdown>
      </div>
    </div>
  );
};

export default AuthContainer(AppNewHeader);
